import { booleanConvert } from './param-convert.js'
import * as joint from '../joint-plus/joint-plus.min.js'

function dataReturn(context, type, data) {
  context.props.data.param.export = {[type]: data}
  MC.handleEvent(context.props.data, 'export')
}

export function handlePaperExport(context) {
  const paramPaper = context.props.data.param.paper
  const paper = context.paper
  const padding = 1
  if (booleanConvert(paramPaper.exportTo.toSvg, false)) {
    joint.format.toSVG(context.paper, dataReturn.bind(null, context, 'svg'), {preserveDimensions: true, area: paper.getContentBBox().inflate(padding)})
  }
  if (booleanConvert(paramPaper.exportTo.toPng, false)) {
    joint.format.toPNG(context.paper, dataReturn.bind(null, context, 'png'), {area: paper.getContentBBox().inflate(padding)})
  }
  if (booleanConvert(paramPaper.exportTo.toJpeg, false)) {
    joint.format.toJPEG(context.paper, dataReturn.bind(null, context, 'jpeg'), {area: paper.getContentBBox().inflate(padding)})
  }
  delete paramPaper.exportTo
}